<template>
  <div class="map-editor-help">
    <div v-if="trafficCountsHelpShow" class="map-editor-help__container">
      <div class="map-editor-help__subcontainer">
        <div class="map-editor-help__subtitle">
          Создание
        </div>
        <div class="map-editor-help__block">
          <b>ЛКМ</b> - создание объектов general_count_points и count_points
          (создание возможно в местах расположения объектов nodes и links)
        </div>
        <div class="map-editor-help__block">
          <b>Escape</b> - отмена создания объекта и закрытие панели параметров
        </div>
      </div>
      <div class="map-editor-help__subcontainer">
        <div class="map-editor-help__subtitle">
          Редактирование
        </div>
        <div class="map-editor-help__block">
          <b>ЛКМ</b> - выбор объекта, открытие карточки для редактирования
          параметров объекта
        </div>
        <div class="map-editor-help__block">
          <b>Backspace</b> - удаление объекта
        </div>
      </div>
    </div>
    <div
      @click="trafficCountsHelpShow = !trafficCountsHelpShow"
      class="map-editor-help__title"
    >
      <i
        :class="
          trafficCountsHelpShow ? 'el-icon-caret-top' : 'el-icon-caret-right'
        "
      />
      Помощь
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trafficCountsHelpShow: true
    };
  }
};
</script>

<style lang="scss"></style>
